import { render, staticRenderFns } from "./ColumnTransactionStatusExternal.vue?vue&type=template&id=94f1c178&scoped=true"
import script from "./ColumnTransactionStatusExternal.vue?vue&type=script&lang=js"
export * from "./ColumnTransactionStatusExternal.vue?vue&type=script&lang=js"
import style0 from "./ColumnTransactionStatusExternal.vue?vue&type=style&index=0&id=94f1c178&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94f1c178",
  null
  
)

export default component.exports